<template>
  <ms-dynamic-popup
    :maximum="true"
    @shortkeyAction="shortkeyAction"
    @beforeOpen="beforeOpen($event, close)"
    name="ReportOfflineDesigner"
    class="misa-report-designer-offline"
  >
    <template v-slot:content>
      <div class="edit-template-container-v2">
        <div class="template-header">
          <div class="title">Báo cáo ngoại tuyến</div>
          <div class="button-container">
            <a target="_blank">
              <div class="button icon24 help"></div>
            </a>
            <div class="button icon24 close" @click="close"></div>
          </div>
        </div>
        <div class="template-body">
          <div class="right-container m-flex">
            <div class="iframe-preview-container">
              <VueHtml2pdf
                :show-layout="false"
                :float-layout="true"
                :enable-download="false"
                :preview-modal="true"
                filename="hee hee"
                :pdf-quality="2"
                :manual-pagination="true"
                pdf-format="a4"
                pdf-orientation="portrait"
                pdf-content-width="100%"
                ref="html2Pdf"
                :html-to-pdf-options="options"
              >
                <template v-slot:pdf-content>
                  <component
                    :is="componentName"
                    :dataReport="dataReport"
                    @generatePDF="generatePDF"
                    ref="pdfContent"
                  ></component>
                </template>
              </VueHtml2pdf>
            </div>
          </div>
        </div>
        <span
          class="shortkey-default"
          @shortkey="shortkeyAction"
          v-shortkey="{
            Help: ['f1'], //Giúp
            Close: ['esc'], //Đóng
          }"
        ></span>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import {getCurrentInstance, onMounted, ref, reactive, watch, computed} from 'vue';
import basePopup from '@/views/base/basePopup';
import commonFn from '@/commons/commonFunction';
import fileAPI from '@/apis/other/fileAPI.js';
import designReportAPI from '@/apis/report/designReportAPI.js';
import {VueDraggableNext} from 'vue-draggable-next';
import popupUtil from '@/commons/popupUtil';
import {shortkeyStatusbar} from '@/mixins/common/shortkeyStatusbar';
import msFileUpload from '@/components/input/MsFileUpload.vue';
import {showError} from '@/commons/globalMessage';
import VueHtml2pdf from 'vue3-html2pdf';
import html2pdf from 'html2pdf.js';
import c408 from './c4-08_ks.vue';
import ReportAccountVoucher from './reportOffline/ReportAccountVoucher_Offline.vue';
import ReportAccountVoucherOriginCurrency from './reportOffline/ReportAccountVoucherOriginCurrency_Offline.vue';
import bkntNd112020 from './offline/BKNT_ND11_2020.vue';
import bkntNd112020Landscape from './offline/BKNT_ND11_2020_landscape.vue';
import c202a from '@/views/report/reportOffline/C202a_Offline.vue';
import c202b from '@/views/report/reportOffline/C202b_Offline.vue';

export default {
  components: {
    msDynamicPopup,
    msFileUpload,
    draggable: VueDraggableNext,
    showError,
    VueHtml2pdf,
    c408,
    ReportAccountVoucher,
    bkntNd112020,
    bkntNd112020Landscape,
    c202a,
    ReportAccountVoucherOriginCurrency,
    c202b,
  },
  name: 'ReportOfflineDesigner',
  mixins: [shortkeyStatusbar],
  methods: {
    generatePDF(value) {
      if (value) {
        this.$refs.html2Pdf?.generatePdf();
        commonFn.unmask();
      }
    },
  },
  setup: props => {
    const {proxy} = getCurrentInstance();
    const dataReport = ref({});
    const componentName = ref('');
    const orientation = ref('p');
    const beforeOpen = async (e, close) => {
      proxy._param = e.ref.params._rawValue;
      proxy._popup = proxy.$vfm.dynamicModals[proxy.$vfm.dynamicModals.length - 1];
      dataReport.value = {
        dataVoucher: proxy?._param?.dataVoucher?.data ?? proxy?._param?.dataModel,
        dataParam: proxy?._param?.param,
      };
      componentName.value = proxy.getComponentName();
    };

    /**
     * đóng form
     */
    const close = flag => {
      popupUtil.hide('ReportOfflineDesigner');
    };

    /**
     * Lấy tên componenent báo cáo
     */
    const getComponentName = () => {
      var report = '';
      switch (proxy?._param?.report?.report_id) {
        case 'C408_TT19': {
          report = 'c408';
          break;
        }
        case '561.01.ND11.2020_Portrait': {
          report = 'bkntNd112020';
          break;
        }
        case '561.01.ND11.2020': {
          orientation.value = 'l';
          report = 'bkntNd112020Landscape';
          break;
        }
        case 'C2.02a_ND112020_561': {
          report = 'c202a';
          break;
        }
        case 'C2.02b_ND112020_561': {
          report = 'c202b';
          break;
        }
        case '56OriginalCurrency': {
          report = 'ReportAccountVoucherOriginCurrency';
          break;
        }
        case '561AccountantVoucher': {
          report = 'ReportAccountVoucher';
          break;
        }
      }
      return report;
    };

    const options = computed(() => ({
      html2canvas: {
        scale: 3,
      },
      jsPDF: {
        orientation: orientation.value,
      },
      image: {type: 'jpeg', quality: 1},
    }));

    return {
      beforeOpen,
      close,
      dataReport,
      componentName,
      getComponentName,
      options,
    };
  },
};
</script>

<style lang="scss">
@import './ReportDesigner.scss';
.misa-report-designer-offline {
  .iframe-preview-container {
    padding: 0 0 !important;
  }
  .pdf-preview {
    width: 100% !important;
    height: 100% !important;
    top: 50px !important;
    transform: unset !important;
    left: 0 !important;
  }

  .vue-html2pdf .pdf-preview button {
    display: none !important;
  }
}
</style>
